import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { TApplicationReportContent } from '~/components/ApplicationReports/types.ts';
import {
  formatDate,
  getApplicationType,
  getStatus,
} from '~/components/ApplicationReports/utils/utils.tsx';
import {
  applicationTypeSelect,
  createdAtSelect,
  identificationSearch,
  identificationSelect,
  lastUpdatedAtSelect,
  statusSelect,
} from '~/components/ApplicationReports/utils/utilsFilter.tsx';
import { ApplicationReportActionCell } from './ApplicationReportActionCell.tsx';
import { ManagerRole } from '~/constants/clientTypes.ts';

const BASE_COL: Partial<GridColDef> = { flex: 1, align: 'center', headerAlign: 'center' };

interface IApplicationReportActions {
  isActionColumnVisible?: boolean;
  roles: ManagerRole[];
  pendingActionId: string | null;
  onArchive: (row: TApplicationReportContent) => void;
  onRestore: (row: TApplicationReportContent) => void;
  onVerification: (row: TApplicationReportContent) => void;
}

export const columns = (
  currentPage: number,
  {
    isActionColumnVisible = true,
    roles,
    pendingActionId,
    onArchive,
    onRestore,
    onVerification,
  }: IApplicationReportActions
): GridColDef[] => [
  {
    field: 'index',
    headerName: '№',
    width: 60,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
    disableColumnMenu: true,
    filterable: false,
    renderCell: (params) => {
      const index = params.api.getAllRowIds().indexOf(params.id);
      return currentPage * 50 + index + 1;
    },
  },
  {
    ...BASE_COL,
    field: 'status',
    headerName: 'Статус заявки',
    sortable: false,
    valueFormatter: (value) => getStatus(value),
    filterOperators: [statusSelect],
  },
  {
    ...BASE_COL,
    field: 'identificationNumber',
    headerName: 'РНОКПП або ЄДРПОУ',
    sortable: false,
    filterOperators: [identificationSearch, identificationSelect],
  },
  {
    ...BASE_COL,
    field: 'applicationType',
    headerName: 'Тип заявки',
    sortable: false,
    valueFormatter: (value) => getApplicationType(value),
    filterOperators: [applicationTypeSelect],
  },
  {
    ...BASE_COL,
    field: 'createdAt',
    headerName: 'Дата відкриття',
    sortable: false,
    valueFormatter: (value) => formatDate(value),
    filterOperators: [createdAtSelect],
  },
  {
    ...BASE_COL,
    field: 'lastUpdatedAt',
    headerName: 'Останні зміни в БД',
    sortable: false,
    valueFormatter: (value) => formatDate(value),
    filterOperators: [lastUpdatedAtSelect],
  },
  {
    ...BASE_COL,
    field: 'toboAddress',
    headerName: 'Точка обслуговування',
    sortable: false,
    filterable: false,
  },
  {
    ...BASE_COL,
    field: 'initiator',
    headerName: 'Ініціатор заявки',
    sortable: false,
    filterable: false,
  },
  {
    ...BASE_COL,
    field: 'financialPhone',
    headerName: 'Фінансовий номер клієнта',
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  {
    ...BASE_COL,
    field: 'applicationWebId',
    headerName: 'Ідентифікатор заявки (номер)',
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  ...(isActionColumnVisible && roles?.includes(ManagerRole.supervisor)
    ? [
        {
          ...BASE_COL,
          field: 'action',
          headerName: 'Дії',
          width: 150,
          sortable: false,
          filterable: false,
          disableColumnMenu: true,
          renderCell: ({ row }: GridRenderCellParams<TApplicationReportContent>) => (
            <ApplicationReportActionCell
              row={row}
              pendingActionId={pendingActionId}
              onArchive={onArchive}
              onRestore={onRestore}
              onVerification={onVerification}
              status={row.status}
            />
          ),
        },
      ]
    : []),
];
